import { getColumnsKeys as getColumnsKeysConfig } from '@/pages/Feed/Feed.config'

export class ColumnsService {
  getColumnsKeys(tokenRoles: readonly string[]): string[] | null | undefined {
    return getColumnsKeysConfig(tokenRoles)
  }

  validateColumns(columns: string[] | null | undefined): boolean {
    return Array.isArray(columns) && columns.length > 0
  }
}
